import { render } from "./MarketingEmails.vue?vue&type=template&id=da7a9e66&scoped=true"
import script from "./MarketingEmails.vue?vue&type=script&lang=js"
export * from "./MarketingEmails.vue?vue&type=script&lang=js"

import "./MarketingEmails.vue?vue&type=style&index=0&id=da7a9e66&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da7a9e66"]])

export default __exports__